import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as GasrecSavingTypes,
  Creators as RecSavingActions,
} from '../ducks/RecSaving';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';
import { isUnexpectedError, businessMessage, GENERIC_ERROR } from '../../util/apiError';
import { reportApiError } from '../../util/glitchtip';

function* getGasrecSavings({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/savings-accounts', {
      params: payload,
    });
    if (status === 200) {
      yield put(RecSavingActions.getGasrecSavingSuccess(data));
    }
    else{
      Sentry.captureMessage('getGasrecSavings failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      RecSavingActions.getGasrecSavingError('Error listing Gasrecs')
    );
  }
}


function* postGasrecSaving({ payload }) {
  try {
      const { status } = yield call(api.post, '/savings-accounts', payload, { skipSentry: true });
      if (status === 200) {
        yield put(RecSavingActions.postGasrecSavingSuccess());
      }
      else{
        Sentry.captureMessage('postGasrecSaving failed: status not 200', {
          level: 'error',
          extra: { payload, status },
        });
      }
    } catch (error) {
      const unexpected = isUnexpectedError(error);
      const reference = yield call(reportApiError, error, {
        flow: 'emissao-saving',
        endpoint: '/savings-accounts',
        payload,
        unexpected,
      });
      yield put(
        RecSavingActions.postGasrecSavingError({
          message: unexpected ? GENERIC_ERROR : businessMessage(error) || GENERIC_ERROR,
          reference,
          unexpected,
        })
      );
    }
  }

  function* putGasrecSaving({ payload }) {
    const { id } = payload;

    try {
      const { status } = yield call(api.put, `/savings-accounts/${id}`, payload, { skipSentry: true });
      if (status === 200) {
        yield put(RecSavingActions.putGasrecSavingSuccess());
      }
      else{
        Sentry.captureMessage('putGasrecSaving failed: status not 200', {
          level: 'error',
          extra: { payload, status },
        });
      }
    } catch (error) {
      const unexpected = isUnexpectedError(error);
      const reference = yield call(reportApiError, error, {
        flow: 'emissao-saving',
        endpoint: `/savings-accounts/${id}`,
        payload,
        unexpected,
      });
      yield put(
        RecSavingActions.putGasrecSavingError({
          message: unexpected ? GENERIC_ERROR : businessMessage(error) || GENERIC_ERROR,
          reference,
          unexpected,
        })
      );
    }
  }


function* getGasrecsWatcher() {
  yield takeLatest(GasrecSavingTypes. GET_GASRECS_SAVINGS, getGasrecSavings);
}

function* postGasrecWatcher() {
  yield takeLatest(GasrecSavingTypes.POST_GASRECS_SAVINGS, postGasrecSaving);
}

function* putGasrecWatcher() {
  yield takeLatest(GasrecSavingTypes.PUT_GASRECS_SAVINGS, putGasrecSaving);
}

// function* getGasrecByIdWatcher() {
//   yield takeLatest(GasrecSavingTypes.GET_GASREC_PARTICIPANT_BY_ID, getGasrecSavingById);
// }

export default function* rootSaga() {
  yield all([
    fork(getGasrecsWatcher),
    fork(postGasrecWatcher),
    fork(putGasrecWatcher),
    // fork(getGasrecByIdWatcher),
  ]);
}
